var map = {
	"./404.svg": "4c55",
	"./advisor-dashboard/icons/blue.svg": "4fd2",
	"./advisor-dashboard/icons/green.svg": "c04b",
	"./advisor-dashboard/icons/orange.svg": "a33d",
	"./advisor-dashboard/icons/pink.svg": "7693",
	"./button-tiles/Card1.jpg": "7cac",
	"./button-tiles/Card2.jpg": "40e3",
	"./button-tiles/Card3.jpg": "ae74",
	"./email_icon.svg": "c1a1",
	"./image-text-banner-images/Image2.jpg": "5a0b",
	"./image-text-banner-images/Page1A.jpg": "95f8",
	"./image-text-banner-images/Page1B.jpg": "2a18",
	"./image-text-banner-images/Page1BB.jpg": "418f",
	"./image-text-banner-images/Page2A.jpg": "6da7",
	"./image-text-banner-images/Page3A.jpg": "4663",
	"./image-text-banner-images/Page3B.jpg": "fd0a",
	"./info-tiles/Conveyance.svg": "9210",
	"./info-tiles/Debt.svg": "2a64",
	"./info-tiles/Estate-duty.svg": "e53f",
	"./info-tiles/Executor-fees.svg": "0b80",
	"./info-tiles/Experts.svg": "3a40",
	"./info-tiles/Legal.svg": "880e",
	"./info-tiles/Online-icon.svg": "e1a1",
	"./info-tiles/Rating.svg": "70dc",
	"./info-tiles/SouthAfricans.svg": "e2d2",
	"./info-tiles/Storage.svg": "520f",
	"./info-tiles/Support.svg": "cf0f",
	"./info-tiles/Touch-screen.svg": "06fc",
	"./info-tiles/ValidateCheck.svg": "0a0c",
	"./insurance/cash_assist_icon.svg": "e74f",
	"./insurance/close_vector.svg": "ef42",
	"./insurance/cost_assist_icon_new.svg": "e81a",
	"./insurance/customized_cost_calculation.svg": "26f7",
	"./insurance/debt_assist_icon.svg": "cdda",
	"./insurance/delayed_support_icon.svg": "12d8",
	"./insurance/education_assist_icon.svg": "1551",
	"./insurance/estate_assist_icon.svg": "ef8b",
	"./insurance/financial_strain_icon.svg": "3827",
	"./insurance/personal_recommendation.svg": "ca13",
	"./insurance/property_sale_icon.svg": "54a7",
	"./insurance/tax_assist_icon.svg": "91c9",
	"./redesign/articles/Article-image16.jpg": "8e7f",
	"./redesign/articles/Article-image17.jpg": "a519",
	"./redesign/articles/Article-image18.jpg": "6cce",
	"./redesign/articles/Article-image19.jpg": "0fae",
	"./redesign/articles/Article-image20.jpg": "c8ff",
	"./redesign/articles/Article-image21.jpg": "83dc",
	"./redesign/articles/Article-image22.jpg": "1b87",
	"./redesign/articles/Article-image5.jpg": "e44a",
	"./redesign/articles/Article-image8.jpg": "3750",
	"./redesign/articles/EstatePlanning.jpg": "9a91",
	"./redesign/articles/Multilingual-article.png": "d9d6",
	"./redesign/articles/articles2.svg": "08e6",
	"./redesign/articles/articles3.svg": "919f",
	"./redesign/articles/articles4.jpg": "5d4b",
	"./redesign/articles/articles5.jpg": "b742",
	"./redesign/backgrounds/Shape Copy.svg": "6975",
	"./redesign/backgrounds/banner-pattern.svg": "2083",
	"./redesign/backgrounds/country-pattern.svg": "ad8c",
	"./redesign/backgrounds/green-accent-1.svg": "b00b",
	"./redesign/backgrounds/green-accent-2.svg": "b9c8",
	"./redesign/backgrounds/purple-accent.svg": "488f",
	"./redesign/common/chevron_down.svg": "5f72",
	"./redesign/common/placeholder.svg": "52cb",
	"./redesign/faqs/faq1.png": "4808",
	"./redesign/faqs/faq2.png": "eaef",
	"./redesign/faqs/faq3.png": "0f20",
	"./redesign/faqs/faq4.png": "785d",
	"./redesign/hero-bar/active.svg": "e758",
	"./redesign/hero-bar/articles/1024.svg": "29b8",
	"./redesign/hero-bar/articles/1280.svg": "8f7c",
	"./redesign/hero-bar/articles/1440.svg": "160d",
	"./redesign/hero-bar/articles/360.svg": "1108",
	"./redesign/hero-bar/articles/600.svg": "8bfa",
	"./redesign/hero-bar/articles/720.svg": "b0a7",
	"./redesign/hero-bar/articles/840.svg": "9897",
	"./redesign/hero-bar/articles/960.svg": "074b",
	"./redesign/hero-bar/calculator/1024.svg": "9404",
	"./redesign/hero-bar/calculator/1280.svg": "0e05",
	"./redesign/hero-bar/calculator/1440.svg": "7f3e",
	"./redesign/hero-bar/calculator/360.svg": "e779",
	"./redesign/hero-bar/calculator/600.svg": "c717",
	"./redesign/hero-bar/calculator/720.svg": "deee",
	"./redesign/hero-bar/calculator/840.svg": "5fe4",
	"./redesign/hero-bar/calculator/960.svg": "1d0e",
	"./redesign/hero-bar/custom-landing-pages/1024.jpg": "7f36",
	"./redesign/hero-bar/custom-landing-pages/1280.jpg": "4987",
	"./redesign/hero-bar/custom-landing-pages/1440.jpg": "51c9",
	"./redesign/hero-bar/custom-landing-pages/360.jpg": "0260",
	"./redesign/hero-bar/custom-landing-pages/600.jpg": "e556",
	"./redesign/hero-bar/custom-landing-pages/720.jpg": "3038",
	"./redesign/hero-bar/custom-landing-pages/840.jpg": "9d25",
	"./redesign/hero-bar/custom-landing-pages/960.jpg": "aee1",
	"./redesign/hero-bar/faqs/1024.svg": "af47",
	"./redesign/hero-bar/faqs/1280.svg": "6939",
	"./redesign/hero-bar/faqs/1440.svg": "2088",
	"./redesign/hero-bar/faqs/360.svg": "474e",
	"./redesign/hero-bar/faqs/600.svg": "cf75",
	"./redesign/hero-bar/faqs/720.svg": "8ece",
	"./redesign/hero-bar/faqs/840.svg": "faa8",
	"./redesign/hero-bar/faqs/960.svg": "e930",
	"./redesign/hero-bar/how-it-works/1024.svg": "ec00",
	"./redesign/hero-bar/how-it-works/1280.svg": "2c90",
	"./redesign/hero-bar/how-it-works/1440.svg": "fe30",
	"./redesign/hero-bar/how-it-works/360.svg": "c848",
	"./redesign/hero-bar/how-it-works/600.svg": "e33d",
	"./redesign/hero-bar/how-it-works/720.svg": "bb98",
	"./redesign/hero-bar/how-it-works/840.svg": "dc8e",
	"./redesign/hero-bar/how-it-works/960.svg": "70d5",
	"./redesign/hero-bar/inactive.svg": "6c7c",
	"./redesign/hero-bar/om-logo-header.svg": "6349",
	"./redesign/hero-bar/our-solutions/1024.svg": "d1e2",
	"./redesign/hero-bar/our-solutions/1280.svg": "682c",
	"./redesign/hero-bar/our-solutions/1440.svg": "5a3e",
	"./redesign/hero-bar/our-solutions/360.svg": "0563",
	"./redesign/hero-bar/our-solutions/600.svg": "ded2",
	"./redesign/hero-bar/our-solutions/720.svg": "918a",
	"./redesign/hero-bar/our-solutions/840.svg": "6cab",
	"./redesign/hero-bar/our-solutions/960.svg": "c9b2",
	"./redesign/hero-bar/proposed/old/1024.svg": "5b68",
	"./redesign/hero-bar/proposed/old/1280.svg": "e66b",
	"./redesign/hero-bar/proposed/old/1440.svg": "aaac",
	"./redesign/hero-bar/proposed/old/430.svg": "95b0",
	"./redesign/hero-bar/proposed/old/600.svg": "3fc7",
	"./redesign/hero-bar/proposed/old/720.svg": "40cb",
	"./redesign/hero-bar/proposed/old/840.svg": "3c7c",
	"./redesign/hero-bar/proposed/old/960.svg": "640a",
	"./redesign/home/Home-Calculator.jpg": "8b94",
	"./redesign/home/Home-Customised.jpg": "eaab",
	"./redesign/home/Home-Easy-updates.jpg": "7c06",
	"./redesign/home/Home-Straightforward.jpg": "7ec7",
	"./redesign/how-it-works/HowItWorks-Process.jpg": "bc6b",
	"./redesign/how-it-works/HowItWorks-ProtectYourEstate.jpg": "f2f9",
	"./redesign/how-it-works/HowItWorks-SafeStorage.jpg": "0650",
	"./redesign/how-it-works/HowItWorks-UpdateWill.jpg": "c9e7",
	"./redesign/icons/adviser/calculate.svg": "d032",
	"./redesign/icons/adviser/checklist.svg": "f3b9",
	"./redesign/icons/adviser/conversation.svg": "324c",
	"./redesign/icons/adviser/document.svg": "3427",
	"./redesign/icons/adviser/question-exchange.svg": "5694",
	"./redesign/icons/facebook.svg": "5807",
	"./redesign/icons/instagram.svg": "ab29",
	"./redesign/icons/linkedin.svg": "8f22",
	"./redesign/icons/money.svg": "8d1d",
	"./redesign/icons/question-mark.svg": "f653",
	"./redesign/icons/whatsapp.svg": "b66a",
	"./redesign/icons/x.svg": "5cbc",
	"./redesign/icons/youtube.svg": "ad8f",
	"./redesign/our-solutions/Solutions-CashAssist.jpg": "8cb4",
	"./redesign/our-solutions/Solutions-DebtAssist.jpg": "3b68",
	"./redesign/our-solutions/Solutions-EduAssist.jpg": "e7ad",
	"./redesign/our-solutions/Solutions-EstateAdministration.jpg": "240e",
	"./redesign/our-solutions/Solutions-EstateAssist.jpg": "290c",
	"./redesign/our-solutions/Solutions-EstatePlanningServices.jpg": "5b04",
	"./redesign/our-solutions/Solutions-OnlineWillCreation.jpg": "a3d5",
	"./redesign/our-solutions/Solutions-TaxAssist.jpeg": "86b1",
	"./refer-a-friend/refer-a-friend.svg": "91aa",
	"./sso_icon.svg": "3f94",
	"./sync_circle.svg": "6390"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2300";